var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "identify-coordinates mb-3 mb-sm-4" }, [
    _c("div", { staticClass: "row" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "col d-flex align-items-center px-0" }, [
        _c("div", { staticClass: "coordinates-wrapper" }, [
          _vm.isEditorActive
            ? _c(
                "div",
                {
                  staticClass: "row flex-nowrap no-gutters coordinates-editor",
                },
                [
                  _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c("SimpleInput", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|decimal",
                            expression: "'required|decimal'",
                          },
                        ],
                        staticClass: "city-bg city-bg-sm mb-0",
                        attrs: {
                          readonly: _vm.disabled,
                          disabled: _vm.disabled,
                          id: `input-coordinate-x`,
                          name: `coordinate-x`,
                          type: "number",
                          step: "any",
                          prefix: _vm.prefixX,
                          required: true,
                          "data-vv-scope": _vm.vScope,
                          inputClasses: [
                            {
                              "is-invalid": _vm.fnHasError(
                                `coordinate-x`,
                                _vm.vScope
                              ),
                            },
                          ],
                          error: _vm.fnFirstError(`coordinate-x`, _vm.vScope),
                        },
                        model: {
                          value: _vm.identify.coordinate.x,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.identify.coordinate,
                              "x",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "identify.coordinate.x",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c("SimpleInput", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|decimal",
                            expression: "'required|decimal'",
                          },
                        ],
                        staticClass: "city-bg city-bg-sm mb-0",
                        attrs: {
                          readonly: _vm.disabled,
                          disabled: _vm.disabled,
                          id: `input-coordinate-y`,
                          name: `coordinate-y`,
                          type: "number",
                          step: "any",
                          prefix: _vm.prefixY,
                          required: true,
                          "data-vv-scope": _vm.vScope,
                          inputClasses: [
                            {
                              "is-invalid": _vm.fnHasError(
                                `coordinate-y`,
                                _vm.vScope
                              ),
                            },
                          ],
                          error: _vm.fnFirstError(`coordinate-y`, _vm.vScope),
                        },
                        model: {
                          value: _vm.identify.coordinate.y,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.identify.coordinate,
                              "y",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "identify.coordinate.y",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              )
            : _c("div", { staticClass: "row coordinates-text" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", {
                    staticClass: "coordinates-decimal",
                    domProps: { innerHTML: _vm._s(_vm.coordinateFormatText) },
                  }),
                ]),
              ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "col-auto d-flex align-items-center coordinates-actions pl-sm-0",
        },
        [
          !_vm.isEditorActive
            ? _c(
                "button",
                {
                  staticClass:
                    "btn btn-sm min-w-auto my-0 mx-auto d-block h-100 unfocus bg-light",
                  attrs: {
                    type: "button",
                    "data-toggle": "tooltip-city",
                    title: _vm.$t(
                      `${this.translateID}.copy_to_clipboard.action`
                    ),
                  },
                  on: { click: _vm.copyCoordinateToClipboard },
                },
                [_c("i", { staticClass: "fas fa-copy" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isEditorActive
            ? _c(
                "button",
                {
                  staticClass:
                    "btn btn-sm btn-link min-w-auto my-0 mx-auto d-block h-100 unfocus apply-changes",
                  attrs: {
                    type: "button",
                    disabled: !_vm.hasChanges,
                    "data-toggle": "tooltip-city",
                    title: _vm.$t(`${this.translateID}.editor.apply.action`),
                  },
                  on: { click: _vm.onApplyChanges },
                },
                [_c("i", { staticClass: "fas fa-check" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass:
                "btn btn-sm min-w-auto my-0 mx-auto d-block h-100 unfocus",
              class: _vm.isEditorActive ? "bg-success text-white" : "bg-light",
              attrs: {
                type: "button",
                "data-toggle": "tooltip-city",
                title: _vm.$t(
                  `${this.translateID}.editor.action.` +
                    (_vm.isEditorActive ? "hide" : "show")
                ),
              },
              on: { click: _vm.onChangeEditor },
            },
            [_c("i", { staticClass: "fas fa-pencil-alt" })]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-auto d-flex align-items-center" }, [
      _c("i", { staticClass: "fas fa-map-marker-alt" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }